<template>
  <div
    class="m-wrap-new m-pc"
    v-if="extras1.formBg"
    :style="{
      background:
        extras1.formBg.colorOrBg == 'color'
          ? extras1.formBg.color
          : 'url(' + extras1.formBg.src + ')',
    }"
  >
    <div class="semianr-logo" v-if="extras1 && extras1.formLogo.display == '1'">
      <img
        :src="
          isSetting != '1'
            ? extras1.headerLogo && extras1.headerLogo.src
            : './images/logo_new.png'
        "
        alt=""
      />
    </div>
    <div class="seminar-info" v-if="isSetting != '1'">
      <div
        class="seminar-info-new"
        v-if="extras1 && extras1.textSetting.display == '1'"
        :class="extras1.BannerText.textAlign"
      >
        <div class="content">
          <div
            v-if="extras1.textSetting.subTitle !== 'hide'"
            class="seminar-title"
            :style="{
              color:
                extras1.textSetting.subTitle == 'custom'
                  ? extras1.textSetting.subTitleFontColor
                  : '',
              'font-size':
                extras1.textSetting.subTitle == 'custom'
                  ? extras1.textSetting.subTitleFontSize + 'px'
                  : '',
              'font-weight':
                extras1.textSetting.subTitle == 'custom'
                  ? extras1.textSetting.subTitleFontWeight == 'on'
                    ? '900'
                    : ''
                  : '',
              'font-style':
                extras1.textSetting.subTitle == 'custom'
                  ? extras1.textSetting.subTitleFontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
            }"
          >
            {{ getSubTitleText() }}
          </div>
          <div
            v-if="extras1.textSetting.title !== 'hide'"
            class="seminar-slogan"
            :style="{
              color:
                extras1.textSetting.title == 'custom'
                  ? extras1.textSetting.titleFontColor
                  : '',
              'font-size':
                extras1.textSetting.title == 'custom'
                  ? extras1.textSetting.titleFontSize + 'px'
                  : '',
              'font-weight':
                extras1.textSetting.title == 'custom'
                  ? extras1.textSetting.titleFontWeight == 'on'
                    ? '900'
                    : ''
                  : '',
              'font-style':
                extras1.textSetting.title == 'custom'
                  ? extras1.textSetting.titleFontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
            }"
          >
            {{ getTitleText() }}
          </div>
          <div class="semianr-time">
            <div
              v-if="extras1.textSetting.timeTitle !== 'hide'"
              class="_title"
              :style="{
                color:
                  extras1.textSetting.timeTitle == 'custom'
                    ? extras1.textSetting.timeTitleFontColor
                    : '',
                'font-size':
                  extras1.textSetting.timeTitle == 'custom'
                    ? extras1.textSetting.timeTitleFontSize + 'px'
                    : '',
                'font-weight':
                  extras1.textSetting.timeTitle == 'custom'
                    ? extras1.textSetting.timeTitleFontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
                'font-style':
                  extras1.textSetting.timeTitle == 'custom'
                    ? extras1.textSetting.timeTitleFontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'background-color':
                  extras1.textSetting && extras1.textSetting.titleBgColor
                    ? extras1.textSetting.titleBgColor
                    : 'transparent',
              }"
            >
              {{ getTimeTitleText() }}
            </div>
            <div
              v-if="extras1.textSetting.time !== 'hide'"
              class="_time"
              :style="{
                color:
                  extras1.textSetting.time == 'custom'
                    ? extras1.textSetting.timeFontColor
                    : '',
                'font-size':
                  extras1.textSetting.time == 'custom'
                    ? extras1.textSetting.timeFontSize + 'px'
                    : '',
                'font-weight':
                  extras1.textSetting.time == 'custom'
                    ? extras1.textSetting.timeFontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
                'font-style':
                  extras1.textSetting.time == 'custom'
                    ? extras1.textSetting.timeFontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'background-color':
                  extras1.textSetting && extras1.textSetting.timeBgColor
                    ? extras1.textSetting.timeBgColor
                    : 'transparent',
              }"
            >
              {{ getTimeText() }}
            </div>
          </div>
          <div class="semianr-time">
            <div
              v-if="extras1.textSetting.addressTitle !== 'hide'"
              class="_title"
              :style="{
                color:
                  extras1.textSetting.addressTitle == 'custom'
                    ? extras1.textSetting.addressTitleFontColor
                    : '',
                'font-size':
                  extras1.textSetting.addressTitle == 'custom'
                    ? extras1.textSetting.addressTitleFontSize + 'px'
                    : '',
                'font-weight':
                  extras1.textSetting.addressTitle == 'custom'
                    ? extras1.textSetting.addressTitleFontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
                'font-style':
                  extras1.textSetting.addressTitle == 'custom'
                    ? extras1.textSetting.addressTitleFontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'background-color':
                  extras1.textSetting && extras1.textSetting.titleBgColor
                    ? extras1.textSetting.titleBgColor
                    : 'transparent',
              }"
            >
              {{ getAddressTitleText() }}
            </div>
            <div
              v-if="extras1.textSetting.address !== 'hide'"
              class="_time"
              :style="{
                color:
                  extras1.textSetting.address == 'custom'
                    ? extras1.textSetting.addressFontColor
                    : '',
                'font-size':
                  extras1.textSetting.address == 'custom'
                    ? extras1.textSetting.addressFontSize + 'px'
                    : '',
                'font-weight':
                  extras1.textSetting.address == 'custom'
                    ? extras1.textSetting.addressFontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
                'font-style':
                  extras1.textSetting.address == 'custom'
                    ? extras1.textSetting.addressFontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'background-color':
                  extras1.textSetting && extras1.textSetting.addressBgColor
                    ? extras1.textSetting.addressBgColor
                    : 'transparent',
              }"
            >
              {{ getAddressText() }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="seminar-info" v-if="isSetting == '1'">
      <div
        class="seminar-info-new"
        v-if="extras1 && extras1.textSetting.display == '1'"
      >
        <div class="content">
          <div
            v-if="extras1.textSetting.subTitle !== 'hide'"
            class="seminar-title"
            :style="{
              color:
                extras1.textSetting.subTitle == 'custom'
                  ? extras1.textSetting.subTitleFontColor
                  : '',
              'font-size':
                extras1.textSetting.subTitle == 'custom'
                  ? extras1.textSetting.subTitleFontSize + 'px'
                  : '',
              'font-weight':
                extras1.textSetting.subTitle == 'custom'
                  ? extras1.textSetting.subTitleFontWeight == 'on'
                    ? '900'
                    : ''
                  : '',
              'font-style':
                extras1.textSetting.subTitle == 'custom'
                  ? extras1.textSetting.subTitleFontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
            }"
          >
            2023企业数字化峰会
          </div>
          <div
            v-if="extras1.textSetting.title !== 'hide'"
            class="seminar-slogan"
            :style="{
              color:
                extras1.textSetting.title == 'custom'
                  ? extras1.textSetting.titleFontColor
                  : '',
              'font-size':
                extras1.textSetting.title == 'custom'
                  ? extras1.textSetting.titleFontSize + 'px'
                  : '',
              'font-weight':
                extras1.textSetting.title == 'custom'
                  ? extras1.textSetting.titleFontWeight == 'on'
                    ? '900'
                    : ''
                  : '',
              'font-style':
                extras1.textSetting.title == 'custom'
                  ? extras1.textSetting.titleFontTilt == 'on'
                    ? 'italic'
                    : 'normal'
                  : '',
            }"
          >
            设计连接 新商业
          </div>
          <div class="semianr-time">
            <div
              v-if="extras1.textSetting.timeTitle !== 'hide'"
              class="_title"
              :style="{
                color:
                  extras1.textSetting.timeTitle == 'custom'
                    ? extras1.textSetting.timeTitleFontColor
                    : '',
                'font-size':
                  extras1.textSetting.timeTitle == 'custom'
                    ? extras1.textSetting.timeTitleFontSize + 'px'
                    : '',
                'font-weight':
                  extras1.textSetting.timeTitle == 'custom'
                    ? extras1.textSetting.timeTitleFontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
                'font-style':
                  extras1.textSetting.timeTitle == 'custom'
                    ? extras1.textSetting.timeTitleFontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'background-color':
                  extras1.textSetting && extras1.textSetting.titleBgColor
                    ? extras1.textSetting.titleBgColor
                    : 'transparent',
              }"
            >
              {{ "会议时间" }}
            </div>
            <div
              v-if="extras1.textSetting.time !== 'hide'"
              class="_time"
              :style="{
                color:
                  extras1.textSetting.time == 'custom'
                    ? extras1.textSetting.timeFontColor
                    : '',
                'font-size':
                  extras1.textSetting.time == 'custom'
                    ? extras1.textSetting.timeFontSize + 'px'
                    : '',
                'font-weight':
                  extras1.textSetting.time == 'custom'
                    ? extras1.textSetting.timeFontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
                'font-style':
                  extras1.textSetting.time == 'custom'
                    ? extras1.textSetting.timeFontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'background-color':
                  extras1.textSetting && extras1.textSetting.timeBgColor
                    ? extras1.textSetting.timeBgColor
                    : 'transparent',
              }"
            >
              {{ "2023.12.12-12.13" }}
            </div>
          </div>
          <div class="semianr-time">
            <div
              v-if="extras1.textSetting.addressTitle !== 'hide'"
              class="_title"
              :style="{
                color:
                  extras1.textSetting.addressTitle == 'custom'
                    ? extras1.textSetting.addressTitleFontColor
                    : '',
                'font-size':
                  extras1.textSetting.addressTitle == 'custom'
                    ? extras1.textSetting.addressTitleFontSize + 'px'
                    : '',
                'font-weight':
                  extras1.textSetting.addressTitle == 'custom'
                    ? extras1.textSetting.addressTitleFontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
                'font-style':
                  extras1.textSetting.addressTitle == 'custom'
                    ? extras1.textSetting.addressTitleFontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'background-color':
                  extras1.textSetting && extras1.textSetting.titleBgColor
                    ? extras1.textSetting.titleBgColor
                    : 'transparent',
              }"
            >
              {{ "会议地点" }}
            </div>
            <div
              v-if="extras1.textSetting.address !== 'hide'"
              class="_time"
              :style="{
                color:
                  extras1.textSetting.address == 'custom'
                    ? extras1.textSetting.addressFontColor
                    : '',
                'font-size':
                  extras1.textSetting.address == 'custom'
                    ? extras1.textSetting.addressFontSize + 'px'
                    : '',
                'font-weight':
                  extras1.textSetting.address == 'custom'
                    ? extras1.textSetting.addressFontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
                'font-style':
                  extras1.textSetting.address == 'custom'
                    ? extras1.textSetting.addressFontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'background-color':
                  extras1.textSetting && extras1.textSetting.addressBgColor
                    ? extras1.textSetting.addressBgColor
                    : 'transparent',
              }"
            >
              {{ "北京市朝阳区高井文化园路8号" }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="field-area form1"
      :style="{
        background: extras1.formFieldBg
          ? extras1.formFieldBg.colorOrBg == 'color'
            ? extras1.formFieldBg.color
            : 'url(\'' + extras1.formFieldBg.src.replace(/'/g, '\\\'') + '\')'
          : '',
      }"
    >
      <vue-scroll :ops="ops">
        <div
          class="title"
          :class="extras1.formTitle && extras1.formTitle.textAlign"
          :style="{
            'letter-spacing':
              extras1.formTitle && extras1.formTitle.wordWidth
                ? extras1.formTitle.wordWidth + 'px'
                : '',
          }"
          v-if="
            extras1.formTitle &&
            extras1.formTitle.display == 1 &&
            formInfo.status != 2 &&
            !isTrackClosed
          "
        >
          {{ extras1.formTitle && extras1.formTitle.title }}
        </div>
        <CField
          class="field-wrap new"
          :formData="formData"
          :platform="platform"
          v-if="formInfo.status != 2 && !isTrackClosed"
          :rulesJump.sync="rulesJump"
          ref="formRef"
        />
        <div
          v-if="formInfo.status == 2 || isTrackClosedMessage"
          style="
            position: absolute;
            top: 50%;
            width: 100%;
            transform: translateY(-50%);
          "
        >
          <div class="u-success">
            <img :src="imgUrlObj[platform]['over']" alt="" />
          </div>
          <div class="split-line"></div>
          <div class="title">报名已截止！</div>
          <div v-if="formInfo.status == 1">
            <div class="split-line"></div>
            <div class="bottom" style="justify-content: center">
              <a-button
                class="btn-default mt-160"
                v-show="formInfo.identity == 1"
                v-if="
                  extras1.seminarButton && extras1.seminarButton.display == 1
                "
                @click="togoVerifyNew()"
              >
                {{ extras1 | extra("seminarButton.text") }}
              </a-button>
            </div>
          </div>
        </div>
        <div v-else-if="preview || formInfo.status == 1">
          <div class="split-line"></div>
          <div class="bottom">
            <a-button
              class="submit"
              type="primary"
              @click="submit()"
              :disabled="isSubmitting"
              :style="{
                width:
                  extras1.submitButton &&
                  extras1.submitButton.buttonTextStyle == 'custom'
                    ? extras1.submitButton.width + '%'
                    : '',

                color:
                  extras1.submitButton &&
                  extras1.submitButton.buttonTextStyle == 'custom'
                    ? extras1.submitButton.fontColor
                    : '',

                'font-style':
                  extras1.submitButton &&
                  extras1.submitButton.buttonTextStyle == 'custom'
                    ? extras1.submitButton.fontTilt == 'on'
                      ? 'italic'
                      : 'normal'
                    : '',
                'font-weight':
                  extras1.submitButton &&
                  extras1.submitButton.buttonTextStyle == 'custom'
                    ? extras1.submitButton.fontWeight == 'on'
                      ? 'bolder'
                      : ''
                    : '',
                'font-size':
                  extras1.submitButton &&
                  extras1.submitButton.buttonTextStyle == 'custom'
                    ? extras1.submitButton.fontSize + 'px'
                    : '',
              }"
            >
              {{ extras1 | extra("submitButton.text") }}
            </a-button>
            <a-button
              class="btn-default"
              v-show="formInfo.identity == 1"
              v-if="extras1.seminarButton && extras1.seminarButton.display == 1"
              @click="togoVerifyNew()"
            >
              {{ extras1 | extra("seminarButton.text") }}
            </a-button>
          </div>
        </div>
      </vue-scroll>
    </div>
  </div>
</template>

<script>
//import Logo from "@/components/Logo.vue";
//import Banner from "@/components/Banner.vue";
import CField from "@/components/CField.vue";
//import FormStatus from "@/components/FormStatus.vue";
// import Meeting from "@/components/Meeting.vue";
import mixinConfig from "../../mixin/configNew.js";
import mixinMeeting from "../../mixin/meetingNew.js";
import mixin from "../../mixin/form.js";
import i18nMixin from "../../mixin/i18n.js";

export default {
  name: "PcIndex",
  mixins: [mixinConfig, mixinMeeting, mixin, i18nMixin],
  components: {
    //    Logo,
    //    Banner,
    CField,
    //    FormStatus,
    //    Meeting,
  },

  data() {
    return {
      platform: "pc",
      ops: {
        rail: {
          opacity: "1",
          background: "#eeeeee",
          size: "6px",
        },
        bar: {
          size: "6px",
          background: "#cccccc",
          keepShow: true,
        },
      },
      imgUrlObj: {
        pc: {
          nostart: require("@/assets/images/pc/icon-no-start.png"),
          over: require("@/assets/images/pc/icon-over.png"),
        },
        wap: {
          nostart: require("@/assets/images/wap/icon-no-start.png"),
          over: require("@/assets/images/wap/icon-over.png"),
        },
      },
    };
  },

  mounted() {
    if (window == window.parent) {
      if (window.innerHeight < 837) {
        //如果可视区域小于弹窗的本身高度 需要按窗口高度比例缩小
        document
          .getElementById("app")
          .style.setProperty(
            "transform",
            "translateY(-50%) scale(" + (window.innerHeight / 837) * 0.97 + ")"
          );
        //        document.getElementById('app').style.setProperty('transform', 'translateY(-50%) scale(' + 1 / window.devicePixelRatio + ')');
      } else {
        document
          .getElementById("app")
          .style.setProperty("transform", "translateY(-50%)");
      }
      document.getElementById("app").style.setProperty("position", "relative");
      document.getElementById("app").style.setProperty("top", "50%");
    }
  },
  computed: {
    extras1() {
      if (window == window.parent) {
        document.body.style.setProperty(
          "background",
          (this.$store.state.extras.pageBg &&
            this.$store.state.extras.pageBg.color) ||
            "#FFFFFF"
        );
      }
      return this.$store.state.extras;
    },
  },
  methods: {
    getSubTitleText() {
      const config = this.extras1.textSetting;
      debugger;
      return config.text ? config.text : "";
    },
    getTitleText() {
      const config = this.extras1.textSetting;
      return config.titleText ? config.titleText : this.seminarInfo.title || "";
    },
    getTimeTitleText() {
      const config = this.extras1.textSetting;
      return config.timeTitleText || config.text3 || "会议时间";
    },
    getTimeText() {
      const config = this.extras1.textSetting;
      return config.timeText
        ? config.timeText
        : this.handleTimeStamps(
            this.seminarInfo.startTime,
            this.seminarInfo.endTime
          );
    },
    getAddressTitleText() {
      const config = this.extras1.textSetting;
      return config.addressTitleText || "会议地点";
    },
    getAddressText() {
      const config = this.extras1.textSetting;
      return config.addressText
        ? config.addressText
        : this.seminarInfo.address || "";
    },
  },
};
</script>
